import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,_vm._b({attrs:{"outlined":"","color":"primary","value":_vm.value},on:{"input":_vm.updateValue},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$scopedSlots)),function(slot){return {key:slot,fn:function(scope){return [_vm._t(slot,null,null,scope)]}}})],null,true)},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }